import { useEffect } from 'react';
import PropTypes from 'prop-types';
import ModalWrapper from 'common/components/modules/modal-wrapper';
import Flag from 'common/components/elements/flags';
import { getIsFacialDetectionAgeVerificationMethod } from 'sites/utils/utils';
import Intercom from 'common/utils/Intercom'
import { ARTICLE_ID_ON_AGE_VERIFICATION_PRIVACY_POLICY } from 'common/utils/intercom-articles'
import classNames from 'classnames';
import QueryParams from 'sites/utils/QueryParams';
import { AGE_VERIFICATION_REQUIRED_MODAL_QUERY_PARAM_KEY } from '../data';

import './style.scss'
import AgeVerificationInfoList from './modules/age-verification-info-list';

const VerificationRequiredModal = ({
   isMobile,
   siteInfo,
   onClickVerifyMyAge,
   onClickSignIn,
   onCloseModal,
}) => {

   useEffect(() => {
      if(!Boolean(QueryParams.getParam(AGE_VERIFICATION_REQUIRED_MODAL_QUERY_PARAM_KEY))) {
         QueryParams.addQueryParam(AGE_VERIFICATION_REQUIRED_MODAL_QUERY_PARAM_KEY, 'true')
      }

      return () => {
         QueryParams.removeQueryParam(AGE_VERIFICATION_REQUIRED_MODAL_QUERY_PARAM_KEY)
      }
   }, [])

   const getModalDescription = () => {
      if(getIsFacialDetectionAgeVerificationMethod(siteInfo.age_verification_location?.code_segment)) {
         // eslint-disable-next-line no-useless-escape
         return `<h3 dir=\"ltr\" style=\"line-height: 1.38; margin-top: 14pt; margin-bottom: 4pt;\"><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\"><b>Adult Content Warning - Age Verification Required in ${ siteInfo?.age_verification_location?.segment || 'your location' }</b></span></h3><p dir=\"ltr\" style=\"margin-top: 12pt; margin-bottom: 12pt; line-height: 1.38;\"><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">This website contains content intended for adults only. Access is restricted to individuals who are&nbsp;</span><b><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">18 years of age or older</span><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">.</span></b></p><p dir=\"ltr\" style=\"margin-top: 12pt; margin-bottom: 12pt; line-height: 1.38;\"><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">By entering this site, you certify that:</span></p><ul style=\"margin-bottom: 0px; padding-inline-start: 48px;\"><li dir=\"ltr\" aria-level=\"1\" style=\"list-style-type: disc; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\"><p dir=\"ltr\" role=\"presentation\" style=\"margin-top: 12pt; margin-bottom: 0pt; line-height: 1.38;\"><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">You are at least 18 years old.</span></p></li><li dir=\"ltr\" aria-level=\"1\" style=\"list-style-type: disc; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\"><p dir=\"ltr\" role=\"presentation\" style=\"margin-top: 0pt; margin-bottom: 0pt; line-height: 1.38;\"><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">You understand that this website contains adult-oriented material.</span></p></li><li dir=\"ltr\" aria-level=\"1\" style=\"list-style-type: disc; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\"><p dir=\"ltr\" role=\"presentation\" style=\"margin-top: 0pt; margin-bottom: 12pt; line-height: 1.38;\"><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">You agree to our terms and conditions and privacy policy.</span></p></li></ul><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">To comply with ${ siteInfo?.age_verification_location?.segment || 'your location' } law, we use an age verification system to ensure minors cannot access harmful content.&nbsp;</span><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\"><b>Your personal information will NOT BE STORED AFTER VERIFICATION.</b></span><br>`
      }

      if(siteInfo.age_verification_description) {
         return siteInfo.age_verification_description
      }

      return 'This site contains adult content (NSFW). You must verify your age to see the content.'
   }

   return (
      <ModalWrapper
         contentWidth='960px'
         isMobile={ isMobile }
         isPreventDeafault={ false }
         type='confirm'
         icon='age-verification'
         // modalWrapperClassName='!h-full !min-h-[90%] flex flex-col'
         modalWrapperClassName={ classNames({
            '!h-full flex flex-col': true,
            '!max-h-[720px]': !isMobile,
            '!min-h-[90%]': isMobile,
         }) }
         className='h-full'
         withoutCloseButton={ false }
         closeBtnClassName='shrink-0'
         onCloseModal={ onCloseModal }
         title={ (
            <span
               className='text-major dark:text-major-dark font-semibold text-xl leading-6 text-center'
            >
               Age verification required for { siteInfo.age_verification_location && siteInfo.age_verification_location?.segment ? siteInfo.age_verification_location?.segment : '' }
               <Flag
                  width='20px'
                  height='20px'
                  country={ siteInfo.age_verification_location?.country_code }
                  className='inline-flex leading-6 align-middle'
               />
            </span>
         ) }
         description={ getModalDescription() }
         buttonText='Age Verification Privacy Policy'
         buttonIconName='attention-outline'
         buttonClassName='w-full mt-6 shrink-0'
         confirmButtonProperties={ {
            iconPosition: 'left',
         } }
         action={ () => {
            Intercom.showArticle(ARTICLE_ID_ON_AGE_VERIFICATION_PRIVACY_POLICY)
         } }
         secondButtonTitle='Verify my age'
         secondButtonWrapperClassName='w-full shrink-0'
         overrideSecondButtonProps={ {
            primaryColor: true,
            backgroundColor: null,
            textColor: null,
            textClassName: null,
         } }
         secondButtonAction={ onClickVerifyMyAge }
         cancelText='I already have an account - Sign in'
         cancelButtonWrapperClassName='w-full shrink-0'
         cancelButtonAction={ onClickSignIn }
         descriptionColorClass='text-secondary dark:text-secondary-dark age_verification_html_description text-start'
         isScrollableTopPartWithoutButtons
         scrollableContentWrapperClassName='h-full'
      >
         <div
            className='w-full h-full flex items-center mt-6'
         >
            <AgeVerificationInfoList
               isIconsPrimaryColor
               isMobile={ isMobile }
            />
         </div>
      </ModalWrapper>
   )
}

VerificationRequiredModal.propTypes = {
   isMobile: PropTypes.bool,
   siteInfo: PropTypes.object,
   onClickVerifyMyAge: PropTypes.func,
   onClickSignIn: PropTypes.func,
   onCloseModal: PropTypes.func,
}

export default VerificationRequiredModal;
